export default __webpack_public_path__ + "static/media/assets-color_00.d66ec26b.jpg";